import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { isNearEndGame } from '../../Level/LevelStateHelper';
import { ResourceDataSet } from '../../../Utility/Tracking/DataSet/Resource';
import {
    TransactionType,
    TActionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { IGameState } from '../../Game/IGameState';
import { AnyBoosterType } from '../BoosterType';
import { InventoryStateHelper } from 'State/Player/Inventory/InventoryStateHelper';
import { ICardsState } from '../ICardState';
import CardStateHelper from '../CardStateHelper';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import { ArrayHelper } from 'Utility/ArrayHelper';
import { trackResourceEvent } from 'Utility/Tracking/TrackingHelpers/Transaction';

export interface IBaseBoosterBehaviorPlayMeta {
    force?: boolean;
}

export default class BaseBoosterBehavior {
    protected targetIDs: string[] = [];
    public play(state: IGameState, meta?: IBaseBoosterBehaviorPlayMeta): IGameState {
        return state;
    }
    public addCardToTargets(cardsState: ICardsState, cardID: string, includeConnected: boolean = false): void {
        this.targetIDs.push(cardID);

        if (!includeConnected) return;

        const connectedModifiers = CardStateHelper.getModifiersOfType(cardsState, cardID, CardModifierType.connected);
        connectedModifiers.forEach((connectedModifier) => {
            if (connectedModifier.properties.cardID) {
                this.targetIDs.push(connectedModifier.properties.cardID)
            }
        });
        this.targetIDs = this.targetIDs.filter(ArrayHelper.filterOnce);
    }

    public isPlayable(state: IGameState) {
        return (
            this.getInventoryItem(state) > 0 ||
            state.playerState.inventory.coins >= this.getPrice(state)
        );
    }

    protected getPrice(state: IGameState): number {
        return 0;
    }

    protected getInventoryItem(state: IGameState): number {
        return 0;
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        return state;
    }

    protected decrementInventoryItem(state: IGameState, boosterType: AnyBoosterType): IGameState {
        return {
            ...state,
            playerState: InventoryStateHelper.setAnyBooster(
                state.playerState,
                boosterType,
                state.playerState.inventory[boosterType] - 1,
                { queueTask: false }
            ),
        };
    }

    protected incrementBoosterUse(state: IGameState, boosterType: AnyBoosterType): IGameState {
        return {
            ...state,
            levelState: {
                ...state.levelState,
                boosterUses: {
                    ...state.levelState.boosterUses,
                    [boosterType]:
                    state.levelState.boosterUses[boosterType] + 1,
                },
            },
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        const price = this.getPrice(state);
        track('mCoinsSpent', price, TrackMethod.ADD);
        if (isNearEndGame(state)) {
            track('mLossAversionCoinsSpent', price, TrackMethod.ADD);
        }

        state = {
            ...state,
            playerState: InventoryStateHelper.spendCoins(
                state.playerState,
                this.getPrice(state)
            ),
        };

        trackResourceEvent(state, { tActionType: TActionType.BOOSTER_USE, transactionType: TransactionType.COIN_PURCHASE });

        return state;
    }

    protected consumeItemOrCoins(state: IGameState): IGameState {
        track('tActionType', TActionType.BOOSTER_USE);
        if (this.getInventoryItem(state) > 0) {
            state = this.spendInventoryItem(state);
        } else {
            state = this.spendCoins(state);
        }

        trackResourceEvent(state, { tActionType: TActionType.BOOSTER_USE, transactionType: TransactionType.INVENTORY });

        return state;
    }

    protected trackCoinsSpent(
        state: IGameState,
        key: keyof ResourceDataSet
    ): void {
        try {
            const price: number = this.getPrice(state);
            track('transactionType', TransactionType.COIN_PURCHASE);
            track(key, price, TrackMethod.ADD);
        } catch (e) {
            console.warn(e);
        }
    }
}
